/* eslint-disable */ import { attributeSelectionComponent, memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { Handing } from '../model/index.js';
export const adjustableDoorCabinetComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'handing', true).withAlias('AdjustableDoorCabinet').attach(memoEval((self)=>[
            self.handing,
            self.$handingOptions
        ], (handing, $handingOptions)=>({
            value: handing,
            options: $handingOptions
        })), (state)=>{
        Handing.assert(state.value);
        return {
            handing: state.value
        };
    }),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'doorLeft', true).withAlias('AdjustableDoorCabinet').withFilter((s)=>s.$doorLeftFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_FRONT_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'doorRight', true).withAlias('AdjustableDoorCabinet').withFilter((s)=>s.$doorRightFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_FRONT_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'doorTop', true).withAlias('AdjustableDoorCabinet').withFilter((s)=>s.$doorTopFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_FRONT_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'handleLeft', true).withAlias('AdjustableDoorCabinet').withFilter((s)=>s.$handleLeftFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_HANDLE',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'handleRight', true).withAlias('AdjustableDoorCabinet').withFilter((s)=>s.$handleRightFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_HANDLE',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'handleTop', true).withAlias('AdjustableDoorCabinet').withFilter((s)=>s.$handleTopFilter).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_HANDLE',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'doorLeft', true).withAlias('AdjustableDoorCabinet').attach(memoEval((self)=>[
            self.$doorLeftOffsetX,
            self.$doorOffsetY,
            self.$doorOffsetZ,
            self.$doorWidth,
            self.$doorModelWidthScaleZero,
            self.$doorModelWidthScaleOne,
            self.$doorHeight,
            self.$doorModelHeightScaleZero,
            self.$doorModelHeightScaleOne
        ], ($doorLeftOffsetX, $doorOffsetY, $doorOffsetZ, $doorWidth, $doorModelWidthScaleZero, $doorModelWidthScaleOne, $doorHeight, $doorModelHeightScaleZero, $doorModelHeightScaleOne)=>({
            offsetX: $doorLeftOffsetX,
            offsetY: $doorOffsetY,
            offsetZ: $doorOffsetZ,
            morphTargetInfluences: {
                Width: {
                    value: $doorWidth,
                    scaleZero: $doorModelWidthScaleZero,
                    scaleOne: $doorModelWidthScaleOne
                },
                Length: {
                    value: $doorHeight,
                    scaleZero: $doorModelHeightScaleZero,
                    scaleOne: $doorModelHeightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'doorRight', true).withAlias('AdjustableDoorCabinet').attach(memoEval((self)=>[
            self.$doorRightOffsetX,
            self.$doorOffsetY,
            self.$doorOffsetZ,
            self.$doorWidth,
            self.$doorModelWidthScaleZero,
            self.$doorModelWidthScaleOne,
            self.$doorHeight,
            self.$doorModelHeightScaleZero,
            self.$doorModelHeightScaleOne
        ], ($doorRightOffsetX, $doorOffsetY, $doorOffsetZ, $doorWidth, $doorModelWidthScaleZero, $doorModelWidthScaleOne, $doorHeight, $doorModelHeightScaleZero, $doorModelHeightScaleOne)=>({
            offsetX: $doorRightOffsetX,
            offsetY: $doorOffsetY,
            offsetZ: $doorOffsetZ,
            morphTargetInfluences: {
                Width: {
                    value: $doorWidth,
                    scaleZero: $doorModelWidthScaleZero,
                    scaleOne: $doorModelWidthScaleOne
                },
                Length: {
                    value: $doorHeight,
                    scaleZero: $doorModelHeightScaleZero,
                    scaleOne: $doorModelHeightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'doorTop', true).withAlias('AdjustableDoorCabinet').attach(memoEval((self)=>[
            self.$doorLeftOffsetX,
            self.$doorOffsetY,
            self.$doorOffsetZ,
            self.$doorWidth,
            self.$doorModelWidthScaleZero,
            self.$doorModelWidthScaleOne,
            self.$doorHeight,
            self.$doorModelHeightScaleZero,
            self.$doorModelHeightScaleOne
        ], ($doorLeftOffsetX, $doorOffsetY, $doorOffsetZ, $doorWidth, $doorModelWidthScaleZero, $doorModelWidthScaleOne, $doorHeight, $doorModelHeightScaleZero, $doorModelHeightScaleOne)=>({
            offsetX: $doorLeftOffsetX,
            offsetY: $doorOffsetY,
            offsetZ: $doorOffsetZ,
            morphTargetInfluences: {
                Width: {
                    value: $doorWidth,
                    scaleZero: $doorModelWidthScaleZero,
                    scaleOne: $doorModelWidthScaleOne
                },
                Length: {
                    value: $doorHeight,
                    scaleZero: $doorModelHeightScaleZero,
                    scaleOne: $doorModelHeightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'handleLeft', true).withAlias('AdjustableDoorCabinet').attach(memoEval((self)=>[
            self.$handleLeftOffsetX,
            self.$handleOffsetY,
            self.$handleOffsetZ,
            self.$handleLength,
            self.$handleModelScaleZero,
            self.$handleModelScaleOne
        ], ($handleLeftOffsetX, $handleOffsetY, $handleOffsetZ, $handleLength, $handleModelScaleZero, $handleModelScaleOne)=>({
            offsetX: $handleLeftOffsetX,
            offsetY: $handleOffsetY,
            offsetZ: $handleOffsetZ,
            morphTargetInfluences: {
                Length: {
                    value: $handleLength,
                    scaleZero: $handleModelScaleZero,
                    scaleOne: $handleModelScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'handleRight', true).withAlias('AdjustableDoorCabinet').attach(memoEval((self)=>[
            self.$handleRightOffsetX,
            self.$handleOffsetY,
            self.$handleOffsetZ,
            self.$handleLength,
            self.$handleModelScaleZero,
            self.$handleModelScaleOne
        ], ($handleRightOffsetX, $handleOffsetY, $handleOffsetZ, $handleLength, $handleModelScaleZero, $handleModelScaleOne)=>({
            offsetX: $handleRightOffsetX,
            offsetY: $handleOffsetY,
            offsetZ: $handleOffsetZ,
            morphTargetInfluences: {
                Length: {
                    value: $handleLength,
                    scaleZero: $handleModelScaleZero,
                    scaleOne: $handleModelScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'handleTop', true).withAlias('AdjustableDoorCabinet').attach(memoEval((self)=>[
            self.$handleTopOffsetX,
            self.$handleTopOffsetY,
            self.$handleOffsetZ,
            self.$handleLength,
            self.$handleModelScaleZero,
            self.$handleModelScaleOne
        ], ($handleTopOffsetX, $handleTopOffsetY, $handleOffsetZ, $handleLength, $handleModelScaleZero, $handleModelScaleOne)=>({
            offsetX: $handleTopOffsetX,
            offsetY: $handleTopOffsetY,
            offsetZ: $handleOffsetZ,
            rotationZ: Math.PI / 2,
            morphTargetInfluences: {
                Length: {
                    value: $handleLength,
                    scaleZero: $handleModelScaleZero,
                    scaleOne: $handleModelScaleOne
                }
            }
        })))
];

//# sourceMappingURL=adjustable-door-cabinet.js.map